import React, { useState } from 'react';
import { Dialog as PrimeDialog, DialogProps as PrimeDialogProps } from 'primereact/dialog';
import 'primereact/dialog/dialog.min.css';
import cn from 'classnames';

import { Footer, FooterProps } from './footer';
import classes from './dialog.module.scss';

type TDialogProps = {
  width?: string,
  height?: string,
  children: React.ReactNode;
  rootClassName?: string;
  onReject?: () => void;
} & Omit<PrimeDialogProps, 'onHide' > & FooterProps;

const Dialog = (props: TDialogProps): JSX.Element => {
  const [isVisible, setIsVisible] = useState(props.visible);
  const handleClose = () => {
    props.onReject && props.onReject();

    setIsVisible(false);
  }

  return (
    <PrimeDialog
      blockScroll
      visible={isVisible}
      style={{ width: props.width, height: props.height }}
      className={cn(classes.root, props.rootClassName, props.onAccept && classes.confirmationModal)}
      footer={!props.onAccept ? null :
        <Footer
          isLoading={props.isLoading}
          isPreviousDisable={props.isPreviousDisable}
          isAcceptDisable={props.isAcceptDisable}

          footerLeftSection={props.footerLeftSection}

          previousLabel={props.previousLabel}
          acceptLabel={props.acceptLabel}
          rejectLabel={props.rejectLabel}

          onPrevious={props.onPrevious}
          onAccept={props.onAccept}
          onReject={handleClose}
        />
      }
      {...props}
      contentClassName={cn(props.contentClassName, { [classes.closable]: !props.closable } )}
      onHide={handleClose}
    />
  );
}

Dialog.defaultProps = {
  rootClassName: undefined,
  visible: false,
  resizable: false,
  draggable: false,
}

export { Dialog, TDialogProps }
